<template>
  <dialog-layout
    :title="title"
    :fullscreen="fullscreen"
    :navIcon="navIcon"
    :dark="dark"
    @pop-dialog="$emit('pop-dialog')"
  >
    <v-container v-if="race">
      <RaceCard :race="race" :clickable="false" flat score-shadow="persist" />

      <template v-for="game in reversedGames" :key="game.id">
        <Transition appear
          @before-enter="beforeCardEnter"
          @enter="cardEnter"
        >
          <div v-if="game.loaded" :key="game.id" class="card-wrap">
            <GameCard
              class="mt-4"
              :game="game"
              :clickable="game.active || isCreator"
            />
          </div>
        </Transition>
      </template>
    </v-container>
  </dialog-layout>
</template>

<script>
import { DialogLayout } from "vue-app-components";
import RaceCard from "@/components/race-card.vue";
import GameCard from "@/components/game-card.vue";

export default {
  name: "dialog-races",
  components: {
    DialogLayout,
    RaceCard,
    GameCard
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: true
    },
    navIcon: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  inject: ["$store"],
  data () {
    return {
      race: null
    };
  },
  created () {
    const id = this.$dialog.getId();
    if (!id) return;
    const handler = (races) => {
      if (!races) return;
      const r = races.find(r => r.id === id);
      if (r) {
        this.race = r;
        unwatch();
      }
    };
    const unwatch = this.$watch(() => this.$store.league?.races, handler);
    handler(this.$store.league?.races);
  },
  computed: {
    title () {
      return `Race to ${this.pointsToWin}`;
    },
    pointsToWin () {
      return this.$store.league?.pointsToWin ?? "";
    },
    reversedGames () {
      return [...this.race.games].reverse();
    },
    isCreator () {
      return this.race.league.userId === this.$store.user.id;
    }
  },
  methods: {
    beforeCardEnter (el) {
      el.style.height = "0";
      el.style.overflow = "hidden";
      el.style.opacity = "0";
      el.style.transform = "scale(0.5)";
    },
    cardEnter (el, done) {
      requestAnimationFrame(() => {
        const naturalHeight = el.scrollHeight;

        el.style.transition = "height 0.3s ease-out, opacity 0.3s ease-out 0.2s, transform 0.3s ease-out 0.2s";
        el.style.height = naturalHeight + "px";
        el.style.opacity = "1";
        el.style.transform = "scale(1)";

        el.addEventListener("transitionend", function onHeightDone () {
          el.removeEventListener("transitionend", onHeightDone);
          el.style.height = "";
          el.style.overflow = "";
          el.style.transition = "";
          done();
        });
      });
    }
  }
};
</script>

